import React, { useContext } from 'react';
import { PapiDeviation, PapiUser } from '@wix/da-papi-types';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useCurrentUser } from '../../../../utils/hooks/useCurrentUser';
import { ResourceType } from '../../../../types/resource';
import AuthorWatchButton from '../../../../Button/AuthorWatchButton';
import DeviationSidebarGrid from '../../../_partials/DeviationSidebarGrid';
import UserLink from '../../../../User/Link/UserLink';
import s from './UserBlock.scss';

interface Props {
  parentDeviation: PapiDeviation;
  user: PapiUser;
  deviations: PapiDeviation[];
  linkTo?: 'home' | 'gallery' | 'favourites' | 'posts' | 'shop' | 'about';
}

const UserBlock: React.FC<React.PropsWithChildren<Props>> = ({
  user,
  deviations,
  parentDeviation,
  linkTo,
}) => {
  const isMobile = useContext(MobileContext);
  const currentUser = useCurrentUser();

  return (
    <BiLoggerContextProvider
      value={{
        sectionid: user.userId,
        section_typeid: ResourceType.USER,
      }}
    >
      <div className={s['root']}>
        <div className={s['user-header']}>
          <UserLink
            className={s['user-link']}
            user={user}
            linkTo={linkTo}
            anchor
            deviationIdSeed={parentDeviation.deviationId}
          />

          {!isMobile && user.userId !== currentUser.userId && (
            <AuthorWatchButton className={s['watch-button']} author={user} />
          )}
        </div>

        <DeviationSidebarGrid
          streamId={`devpage-sidebar-users-${parentDeviation.deviationId}-${user.userId}`}
          className={s['user-grid']}
          parentDeviation={parentDeviation}
          deviations={deviations}
          maxRows={1}
        />
      </div>
    </BiLoggerContextProvider>
  );
};
UserBlock.displayName = 'UserBlock';

export default UserBlock;
